import { render, staticRenderFns } from "./lu-saas-table.vue?vue&type=template&id=2fc8ddc7&"
import script from "./lu-saas-table.vue?vue&type=script&lang=js&"
export * from "./lu-saas-table.vue?vue&type=script&lang=js&"
import style0 from "./lu-saas-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports